var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscription_item",on:{"click":function($event){return _vm.gotoDetail()}}},[_c('img',{staticClass:"subscription_image",attrs:{"src":_vm.menuImage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }